import { render, staticRenderFns } from "./UploadWidget.vue?vue&type=template&id=5b37c9d8&scoped=true&"
import script from "./UploadWidget.vue?vue&type=script&lang=js&"
export * from "./UploadWidget.vue?vue&type=script&lang=js&"
import style0 from "./UploadWidget.vue?vue&type=style&index=0&id=5b37c9d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37c9d8",
  null
  
)

export default component.exports